// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"476":"dh-basis-kart","537":"ca"}[chunkId] || chunkId) + "-chunk-" + {"404":"a5d3b95c30e7f887bfa4","476":"795da7821e586e8c0f5c","537":"a91f0efab49efec3009c"}[chunkId] + ".js";
};